import { Directive, ElementRef, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output, Renderer2 } from '@angular/core';
import { CoreTableSortDirectionEnum, CoreTableSortState } from '../models/table-sort';
import { Subject, takeUntil } from 'rxjs';

/**
 * Tábla headerbe rakható sort directiva (csak tailwindhez)
 * 
 * @example
 * <span class="sort" data-field="szamlaszam" [sortSubject]="sortSubject" [sortDefaults]="_columnSort" (changed)="onSortChanged($event)" tableSortDirection>
 * 
 * <span class="sort" [sortState]="tableSort" [sortSelectedClass]="'font-bold'" [sortSubject]="sortSubject" [sortDefaults]="_columnSort" (changed)="onSortChanged($event)" tableSortDirection>
 */
@Directive({
  selector: '[tableSortDirection]'
})
export class TableSortDirective implements OnInit, OnDestroy {

  @Input() sortSelectedClass: string = 'text-dark';
  @Input() sortDefaults: CoreTableSortState;
  @Input() sortSubject: Subject<CoreTableSortState>;
  @Output() changed: EventEmitter<CoreTableSortState> = new EventEmitter();

  state: CoreTableSortState;
  destroy$: Subject<void> = new Subject();

  constructor(private renderer: Renderer2, private hostElement: ElementRef) {
    //
  }

  ngOnInit(): void {
    
    let field: string;
    if (this.hostElement.nativeElement.getAttribute('data-field')) {
      field = this.hostElement.nativeElement.getAttribute('data-field');
    } else {
      console.warn('Attribute data-field has not defined. Sort disabled!');
      return;
    }

    this.state = this.sortDefaults;

    this.sortSubject.pipe(takeUntil(this.destroy$)).subscribe({ next: (v: CoreTableSortState) => {
      this.state = v;
      this.changeVisual(field);
    }});

    this.changeVisual(field);

  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private changeVisual(field: string): void {

    this.renderer.removeClass(this.hostElement.nativeElement, 'asc');
    this.renderer.removeClass(this.hostElement.nativeElement, 'desc');
    this.renderer.removeClass(this.hostElement.nativeElement, this.sortSelectedClass);

    if (this.state.getColumn() === field) {
      this.renderer.addClass(this.hostElement.nativeElement, this.state.getDirection().toLowerCase());
      this.renderer.addClass(this.hostElement.nativeElement, this.sortSelectedClass);
    }

  }

  @HostListener('click', ['$event'])
  onClick($event: MouseEvent): void {
    
    let field: string;
    if (this.hostElement.nativeElement.getAttribute('data-field')) {
      field = this.hostElement.nativeElement.getAttribute('data-field');
    } else {
      return;
    }

    if (this.state.getColumn() != field) {
      // új mező van, ezt a mezőt is be kell állítsuk
      this.changeField(field);
    } else {
      // nem új mező van, hanem a régit kattintottuk
      this.changeDirection();
    }

    this.changed.emit(this.state);
  }

  private changeField(field: string): void {
    this.state.setColumn(field);
    this.state.setDirection(CoreTableSortDirectionEnum.DESC);
  }

  private changeDirection(): void {
    this.state.setDirection((this.state.getDirection() === CoreTableSortDirectionEnum.ASC) ? CoreTableSortDirectionEnum.DESC : CoreTableSortDirectionEnum.ASC);
  }

}
